import { useParams, useSearchParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/layout/PageHeader';
import LocalizedLink from '@/components/shared/LocalizedLink';
import { MethodologyWorkspace } from '@/components/methodologies/MethodologyWorkspace';

/** Thin route wrapper — all the behaviour lives in `MethodologyWorkspace`. */
export default function MethodPage() {
  const { methodId } = useParams<{ methodId: string }>();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation('methodologies');

  if (!methodId) {
    return <Navigate to="/methods" replace />;
  }

  const methodTitle = t(`methods.${methodId}.title`, { defaultValue: '' });
  const methodDescription = t(`methods.${methodId}.why`, { defaultValue: '' });

  if (!methodTitle) {
    return (
      <div className="flex flex-col gap-[24px]">
        <PageHeader title={t('page.notFoundTitle')} description={t('page.notFoundDescription')} />
        <LocalizedLink
          to="/methods"
          className="inline-flex self-start items-center h-[48px] px-[24px] rounded-[16px] bg-[#2197f1] hover:bg-[#1a7acc] font-segoe font-semibold text-[16px] leading-[24px] text-white transition-colors"
        >
          ← {t('page.backToCatalog')}
        </LocalizedLink>
      </div>
    );
  }

  return (
    <>
      <LocalizedLink
        to="/methods"
        className="inline-block font-segoe text-[14px] leading-[20px] text-[#2197f1] hover:underline mb-[16px]"
      >
        ← {t('page.backToCatalog')}
      </LocalizedLink>
      <PageHeader title={methodTitle} description={methodDescription} />
      <MethodologyWorkspace methodId={methodId} initialRecordId={searchParams.get('recordId') ?? undefined} />
    </>
  );
}
